<ng-container
  *ngIf="compositePackagingResource$ | async as compositePackagingResource"
>
  <ng-container
    *ngIf="singlePackagingResource$ | async as singlePackagingResource"
  >
    <ng-container *ngIf="packingListResource$ | async as packingListResource">
      <ng-container *ngIf="layoutResource$ | async as layoutResource">
        <ng-container *ngIf="validationResource$ | async as validationResource">
          <hazmatsuite-next-modal
            [title]="packingListResource['AddCombinationPackaging']"
            [showModal]="show"
            [confirmButtonLabel]="packingListResource['ButtonApply']"
            modalSize="xl"
            (closeModal)="cancel()"
            (confirm)="save()"
          >
            <div id="dgd-packing-details" class="col-12">
              <div class="row">
                <div class="col-md-6">
                  <button
                    type="button"
                    class="btn btn-block btn-iconed btn-iconed-default-white btn-iconed-left"
                    (click)="addInnerPackaging()"
                  >
                    {{ compositePackagingResource['AddInnerPackageButton'] }}
                    <i class="btn-icon ifc ifc-tanks" aria-hidden="true"></i>
                  </button>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12 mt-5">
                  <h3>
                    {{ compositePackagingResource['InnerPackagings'] }}
                  </h3>
                  <div id="ch-ggs-web-suite-packing-details">
                    <lib-inner-packaging-item
                      *ngFor="let item of model?.Items"
                      [item]="item"
                      (editPackage)="editPackage(item)"
                      (removeInnerPackage)="removeInnerPackage($event)"
                      (duplicateInnerPackage)="duplicateInnerPackage($event)"
                    ></lib-inner-packaging-item>
                    <span *ngIf="!model?.Items?.length">-</span>
                  </div>
                  <span
                    *ngIf="!model?.Items?.length && formGroup.touched"
                    class="text-danger"
                  >
                    {{ validationResource['InputRequired'] }}
                  </span>
                </div>
              </div>

              <h4>{{ packingListResource['PackagingInfo'] }}</h4>
              <hr />
              <form [formGroup]="formGroup">
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label h4">{{
                    singlePackagingResource['ClosureCountAndType']
                  }}</label>
                  <div class="col-sm-9">
                    <div class="row form-row">
                      <div class="col-sm-3">
                        <div>
                          <input
                            class="form-control"
                            type="number"
                            id="countOfPackagings"
                            formControlName="countOfPackagings"
                          />
                        </div>
                        <span
                          *ngIf="
                            countOfPackagings?.invalid &&
                            (countOfPackagings?.dirty ||
                              countOfPackagings?.touched)
                          "
                          class="text-danger"
                        >
                          {{ validationResource['PositiveInteger'] }}
                        </span>
                      </div>
                      <div class="col-sm-3">
                        <div>
                          <select
                            id="packagingType"
                            formControlName="packagingType"
                            class="form-control"
                            (change)="changePackagingType($event)"
                          >
                            <option
                              *ngFor="
                                let c of packageTypes;
                                trackBy: trackByCode
                              "
                              [value]="c.Id"
                            >
                              {{ c.Text }}
                            </option>
                          </select>
                        </div>
                        <span
                          *ngIf="
                            packagingType?.invalid &&
                            (packagingType?.dirty || packagingType?.touched)
                          "
                          class="text-danger"
                        >
                          {{ validationResource['InputRequired'] }}
                        </span>
                      </div>
                      <div class="col-sm-3">
                        <div>
                          <select
                            formControlName="packagingUnCode"
                            class="form-control"
                            (change)="changePackagingUnCode($event)"
                          >
                            <option
                              *ngFor="
                                let c of packagingUnCodes;
                                trackBy: trackByCode
                              "
                              [value]="c.Id"
                            >
                              {{ c.Text }}
                            </option>
                          </select>
                        </div>
                        <span
                          *ngIf="
                            packagingUnCode?.invalid &&
                            (packagingUnCode?.dirty || packagingUnCode?.touched)
                          "
                          class="text-danger"
                        >
                          {{ validationResource['InputRequired'] }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-sm-3 h4">
                    {{ singlePackagingResource['AmountType'] }}
                  </label>
                  <div class="col-sm-9 row inline-radios">
                    <div class="form-check radio">
                      <input
                        id="singlePackaging"
                        type="radio"
                        formControlName="isTotalQuantity"
                        [value]="false"
                      />&nbsp;
                      <label for="singlePackaging">{{
                        singlePackagingResource['IsSingleQuantity']
                      }}</label>
                    </div>
                    <div class="form-check radio">
                      <input
                        id="totalPackaging"
                        type="radio"
                        formControlName="isTotalQuantity"
                        [value]="true"
                      />&nbsp;
                      <label for="totalPackaging">{{
                        singlePackagingResource['IsTotalQuantity']
                      }}</label>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-sm-3 col-form-label h4">{{
                    compositePackagingResource['GrossWeight']
                  }}</label>
                  <div class="col-sm-9">
                    <div class="row form-row">
                      <div class="col-sm-3">
                        <div>
                          <input
                            class="form-control form-control-mandatory"
                            type="text"
                            id="grossWeight"
                            formControlName="grossWeight"
                          />
                        </div>
                        <span
                          *ngIf="
                            grossWeight?.invalid &&
                            (grossWeight?.dirty || grossWeight?.touched)
                          "
                          class="text-danger"
                        >
                          {{ validationResource['PositiveInteger'] }}
                        </span>
                      </div>
                      <div class="col-sm-3">
                        <label class="col-form-label">{{
                          model.GrossWeightUnitSymbol
                        }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <!-- <div
              class="form-group row"
              *ngIf="model.HasAllPackedInOneQuantityValue"
            >
              <label class="col-sm-3 col-form-label">{{
                compositePackagingResource['QuantityValue']
              }}</label>
              <div class="col-sm-9">
                <div class="row form-row">
                  <div class="col-sm-3">
                    @Html.EditorFor(model => model.AllPackedInOneQuantityValue,
                    new {htmlAttributes = new {@class = "form-control",
                    @disabled = "disabled", onclick =
                    "updateCompositePackageView()"}})
                  </div>
                </div>
              </div>
            </div> -->
              <!--
              <div class="row mt-6">
                <div class="col-md-6">
                  <button
                    type="button"
                    class="btn btn-block btn-iconed btn-iconed-default-white btn-iconed-left w-auto"
                    onclick="closeDgSelectionModal()"
                  >
                    {{ layoutResource['ButtonCancel'] }}
                    <i class="btn-icon ifc-custom ifc-close"></i>
                  </button>
                </div>
                <div
                  class="col-md-6 float-right"
                  *ngIf="model?.Items?.length || 0 > 0"
                >
                  <button
                    type="submit"
                    class="btn btn-block btn-iconed btn-iconed-primary w-auto"
                  >
                    {{ compositePackagingResource['SaveButton']
                    }}<i class="btn-icon ifc-custom ifc-arrow-right"></i>
                  </button>
                </div>
              </div> -->
            </div>
          </hazmatsuite-next-modal>

          <hazmatsuite-next-modal
            [title]="packingListResource['AddInnerPacking']"
            [showModal]="innerPackagingModalOpen"
            [confirmButtonLabel]="
              isEditModal
                ? packingListResource['ButtonApply']
                : compositePackagingResource['AddInnerPackageButton']
            "
            modalSize="xl"
            (closeModal)="innerPackagingModalOpen = false; isEditModal = false"
            (confirm)="
              innerPackingIsValid
                ? isEditModal
                  ? updatePackage()
                  : addPackage()
                : markChildAsTouched()
            "
          >
            <lib-easydgd-inner-packaging-item-editor
              #innerPackaging
              [transportMode]="transportMode"
              [allDangerousGoods]="allDangerousGoods"
              [model]="currentInnerPackage"
              (modelChanged)="currentInnerPackageChanged($event)"
              (valid)="innerPackingIsValid = $event"
            ></lib-easydgd-inner-packaging-item-editor>
          </hazmatsuite-next-modal>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-container>
